function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "g97tlnkhza"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 223",
    style: {
      fill: "#3d6ae6"
    },
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 5",
    style: {
      clipPath: "url(#g97tlnkhza)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 3",
    d: "M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8M3.686 6.287a1.219 1.219 0 1 1 1.219 1.219 1.219 1.219 0 0 1-1.219-1.219m1.04 6.034A3.216 3.216 0 0 1 8.014 9.18a3.216 3.216 0 0 1 3.286 3.14zm6.368-4.814a1.219 1.219 0 1 1 1.219-1.219 1.219 1.219 0 0 1-1.219 1.219",
    style: {
      fill: "#3d6ae6"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNegative);
export default __webpack_public_path__ + "static/media/icon-negative.efe1471081de970ead7cc6e6ee9ad593.svg";
export { ForwardRef as ReactComponent };